import React, { Component } from "react";
import AppCatalogTableRow from "./AppCatalogTableRow";

class AppCatalogTable extends Component {
  render() {
    console.log("AppCatalogTable render... ", this.props.applications);
    var rows = [];
    this.props.applications.forEach(function(app, index) {
      rows.push(<AppCatalogTableRow key={index} app={app} />);
    });
    return (
    <div className="container-fluid appCatalog">
        <div className="row">
            <div className="col-12">
                <div className="row appCatalogTitle py-4">
                    <div className="col-12">
                        <h1><i className="fa fa-cloud-upload-alt" /> My Apps</h1>
                    </div>
                </div>
                <div className="row pb-4">
                    <div className="col-12">
                        <div className="tableWrapper bg-white table-responsive-lg">
                            <table className="table table-striped appCatalogTable">
                                <thead className="thead-dark">
                                    <tr>
                                        <th id="headingAppName" scope="col">App Name</th>
                                        <th id="headingStatus" scope="col">Status</th>
                                        <th id="headingLastUpdate" scope="col">Last Update</th>
                                        <th id="headingUser" scope="col">User</th>
                                    </tr>
                                </thead>
                            {this.props.applications && this.props.applications.length === 0 && (
                                <tbody id="noApps">
                                    <tr>
                                        <td/>
                                        <td id="noAppFound" align="right">
                                            {" "}
                                            No applications found.
                                        </td>
                                        <td/>
                                        <td/>
                                    </tr>
                                </tbody>
                            )}
                            {this.props.applications && this.props.applications.length > 0 && <tbody>{rows}</tbody>}
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
  }
}

export default AppCatalogTable;



// WEBPACK FOOTER //
// ./src/manageMyAccount/AppCatalogTable.js